module.exports = __webpack_public_path__ + "img/hdfk.2df1f86a.png";